import React from "react";
import Modal from "react-bootstrap/Modal";

const LinkAccountConfirmModal = ({
  currentCampaign,
  showModal,
  setShowModal,
  linkUserAndAssociateCapaign,
  setLoading,
  loading,
}) => {
  const handleLinkingCampaign = async () => {
    try {
      setLoading(true);
      await linkUserAndAssociateCapaign(currentCampaign?.campaign_id);
      setLoading(false);
      setShowModal(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title className="program_heading">
            Link with campaigns on UI platform
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to connect google campaign to a platform
            campaign
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-md rounded-pill btn-secondary px-4 d-flex align-items-center justify-content-center"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-md rounded-pill btn-primary px-4  d-flex align-items-center justify-content-center"
            onClick={() => {
              handleLinkingCampaign();
            }}
            disabled={loading}
          >
            {" "}
            {loading ? <span>Loading...</span> : <span>Connect</span>}{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LinkAccountConfirmModal;
